import { render, staticRenderFns } from "./DescriptionTab.vue?vue&type=template&id=5831aafc&scoped=true"
import script from "./DescriptionTab.vue?vue&type=script&lang=js"
export * from "./DescriptionTab.vue?vue&type=script&lang=js"
import style0 from "./DescriptionTab.vue?vue&type=style&index=0&id=5831aafc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5831aafc",
  null
  
)

export default component.exports